module.exports = __webpack_public_path__ + "static/media/34-1.db018ef7.mp3";